<app-command [command]="update$" (success)="saved()">
  <app-details-modal
    [title]="title"
    [saveLabel]="saveLabel"
    [form]="formGroup"
    (cancel)="cancel()"
    (save)="save()">
    <app-details-content>
      <ng-container *appLoad="let data of load$; trackingName: 'trust-details'">
        <form [formGroup]="formGroup">
          <!-- details -->
          <section class="mb-md">
            <h4>Details</h4>

            <div class="row">
              <div class="col-12 col-sm-6 col-lg-6">
                <lds-text-input
                  formControlName="name"
                  label="Name"
                  placeholder="name of trust"
                  [maxlength]="150"
                  [isRequired]="data.schema.trust.name | standardRequirement"
                  [validations]="{
                    required: 'Name is required'
                  }">
                </lds-text-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <lds-select
                  formControlName="trustType"
                  name="trustType"
                  label="Type"
                  [isRequired]="
                    data.schema.trust.trustType | standardRequirement
                  "
                  [options]="
                    data.schema.trust.trustType.options | ldsSelectOption
                  "
                  [validations]="{
                    required: 'Type is required'
                  }">
                </lds-select>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <business-number
                  formControlName="businessNumber"
                  [isRequired]="
                    data.schema.trust.businessNumber | standardRequirement
                  "
                  [showHighlight]="
                    data.schema.trust.businessNumber | standardRequirement
                  "></business-number>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-date-input
                  formControlName="foundationDate"
                  name="foundationDate"
                  label="Foundation date"
                  [isRequired]="
                    data.schema.trust.foundationDate | standardRequirement
                  "
                  [validations]="{
                    date: 'Must be a valid date',
                    dateBefore: 'Must be a date in the past'
                  }">
                </lds-date-input>
              </div>
              <div
                class="col-12 col-sm-6 col-lg-3"
                *ngIf="'NZ' | disableForCountries">
                <lds-select
                  formControlName="jurisdiction"
                  name="jurisdiction"
                  label="Jurisdiction"
                  [isRequired]="
                    data.schema.trust.jurisdiction | standardRequirement
                  "
                  [options]="
                    data.schema.trust.jurisdiction.options | ldsSelectOption
                  ">
                </lds-select>
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <lds-text-input
                  formControlName="settlorName"
                  name="settlorName"
                  label="Settlor name"
                  placeholder="settlor name"
                  [isRequired]="
                    data.schema.trust.settlorName | standardRequirement
                  "
                  [maxlength]="160">
                </lds-text-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-6">
                <lds-text-input
                  formControlName="managerName"
                  name="managerName"
                  label="Manager name"
                  placeholder="manager / appointer name"
                  [isRequired]="
                    data.schema.trust.managerName | standardRequirement
                  "
                  [maxlength]="160">
                </lds-text-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-select
                  formControlName="status"
                  name="status"
                  label="Status"
                  [isRequired]="data.schema.trust.status | standardRequirement"
                  [options]="data.schema.trust.status.options | ldsSelectOption"
                  [validations]="{
                    required: 'Please select a status'
                  }">
                </lds-select>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-select
                  formControlName="contactType"
                  name="contactType"
                  label="Contact type"
                  [isRequired]="
                    data.schema.trust.contactType | standardRequirement
                  "
                  [options]="
                    data.schema.trust.contactType.options | ldsSelectOption
                  ">
                </lds-select>
              </div>
              <div
                class="col-12 col-sm-6 col-lg-6"
                *ngIf="
                  formGroup.controls.contactType.value | displayAffiliateId
                ">
                <lds-text-input
                  formControlName="nmbAffiliateId"
                  label="Affiliate ID"
                  placeholder="Affiliate ID"
                  [isRequired]="
                    data.schema.trust.nmbAffiliateId | standardRequirement
                  "
                  [maxlength]="100"
                  [validations]="{
                    required: 'Affiliate ID is required'
                  }">
                </lds-text-input>
              </div>
            </div>
          </section>

          <!-- trustees -->
          <section class="mb-lg">
            <spark-contacts-trust-trustees
              formControlName="trustees"
              [contacts]="data.content.contacts"
              [isRequired]="data.schema.trust.trustees | standardRequirement">
            </spark-contacts-trust-trustees>
          </section>

          <!-- beneficiaries -->
          <section class="mb-lg">
            <spark-contacts-trust-beneficiaries
              formControlName="beneficiaries"
              [contacts]="data.content.contacts"
              [isRequired]="data.schema.beneficiary | standardRequirement">
            </spark-contacts-trust-beneficiaries>
          </section>

          <section class="mb-lg" *ngIf="!(formGroup.controls.contactType.value | referrerArrangementHidden)">
            <spark-contacts-referrer-arrangement
              formControlName="referrerArrangement"
              [schema]="data.schema.trust.referrerArrangement"
              [isDisabled]="formGroup.controls.nmbAffiliateId.value | referrerArrangementDisabled">
            </spark-contacts-referrer-arrangement>
          </section>

          <section class="mt-sm">
            <div class="tags-section">
              <h4>Tags</h4>
              <lds-card>
                <div class="tags-section__details">
                  <app-tag-input
                    [entityId]="isNewEntity ? '' : trustId"
                    [entityType]="tagEntityType"
                    [showLabel]="false"
                    [readonly]="false"
                    (tagsChanged)="onTagsChanged($event)">
                  </app-tag-input>
                </div>
              </lds-card>
            </div>
          </section>
        </form>
      </ng-container>
    </app-details-content>
  </app-details-modal>
</app-command>
